import type { DeviceCapabilities } from "@paperclip-cloud/shared";
import { api } from "../client";

export interface Device {
  id: string;
  company_id: string;
  name: string;
  hostname: string;
  online: boolean;
  pairing_state: "active" | "pending" | "revoked";
  capabilities: DeviceCapabilities;
  current_step_id: string | null;
  last_seen_at: number;
  created_at: number;
}

export const devicesApi = {
  list: (companyId: string) =>
    api<{ devices: Device[] }>(`/v1/companies/${companyId}/devices`),
  get: (id: string) => api<Device>(`/v1/devices/${id}`),
  rename: (id: string, name: string) =>
    api<Device>(`/v1/devices/${id}`, { method: "PATCH", body: { name } }),
  revoke: (id: string) =>
    api<{ ok: true }>(`/v1/devices/${id}/revoke`, { method: "POST" }),
  pairInit: (companyId: string, deviceName: string = "New computer") =>
    api<{ pairing_id: string; code: string; expires_at: number }>(
      "/v1/devices/pair-init",
      {
        method: "POST",
        body: { company_id: companyId, device_name: deviceName },
      },
    ),
  pairCancel: (pairingId: string) =>
    api<{ ok: true }>(`/v1/devices/pair-init/${pairingId}`, {
      method: "DELETE",
    }),
};
